export default "__VITE_ASSET__CJ8HGPm$__"